import React from 'react';
import { Clock, Smartphone, UserCheck, MapPin } from 'lucide-react';

const FeatureCard = ({ icon: Icon, title, description }) => (
    <div className="feature-card glass-panel">
        <div className="icon-wrapper">
            <Icon size={24} />
        </div>
        <h3>{title}</h3>
        <p>{description}</p>
    </div>
);

const Features = () => {
    const features = [
        {
            icon: Clock,
            title: "Carga Horária Reduzida",
            description: "De 20h para apenas 2h práticas obrigatórias. Você decide quando e como aprende, sem burocracia excessiva."
        },
        {
            icon: Smartphone,
            title: "Teórico 100% Online",
            description: "Estude de graça, de onde estiver. O curso teórico agora é digital e gratuito, mantendo o rigor no exame."
        },
        {
            icon: UserCheck,
            title: "Escolha seu Instrutor",
            description: "Encontre instrutores autônomos credenciados pelo Detran. Veja avaliações e escolha o melhor para você."
        },
        {
            icon: MapPin,
            title: "Pratique Perto de Casa",
            description: "Localize instrutores na sua região. Otimize seu tempo e aprenda no trânsito real do seu bairro."
        }
    ];

    return (
        <section className="features">
            <div className="container">
                <div className="section-header">
                    <h2>O futuro da habilitação</h2>
                    <p>Entenda como a nova resolução muda tudo para melhor.</p>
                </div>
                <div className="features-grid">
                    {features.map((f, i) => (
                        <FeatureCard key={i} {...f} />
                    ))}
                </div>
            </div>

            <style>{`
        .features {
          padding: 4rem 0 6rem;
        }
        .section-header {
          text-align: center;
          margin-bottom: 4rem;
        }
        .section-header h2 {
          font-size: 2.5rem;
          margin-bottom: 1rem;
        }
        .section-header p {
          color: var(--color-text-muted);
          font-size: 1.125rem;
        }
        .features-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
          gap: 2rem;
        }
        .feature-card {
          padding: 2rem;
          transition: transform 0.2s;
        }
        .feature-card:hover {
          transform: translateY(-5px);
        }
        .icon-wrapper {
          width: 48px;
          height: 48px;
          background: rgba(59, 130, 246, 0.1);
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: var(--color-primary);
          margin-bottom: 1.5rem;
        }
        .feature-card h3 {
          font-size: 1.25rem;
          margin-bottom: 0.75rem;
        }
        .feature-card p {
          color: var(--color-text-muted);
          line-height: 1.6;
        }
      `}</style>
        </section>
    );
};

export default Features;
